module.exports = __webpack_public_path__ + "img/bg_教学备课.739efd4b.png";